import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { soonestStatus } from "./docStatus";

export const DocAlert = ({ personal, testId }) => {
  const { t } = useTranslation();
  const status = soonestStatus(personal);
  if (!status) return null;
  return (
    <p
      className={`mt-2 flex items-center gap-1 text-[11px] font-bold ${status.expired ? "text-danger" : "text-warning"}`}
      data-testid={testId}
    >
      <AlertTriangle className="h-3.5 w-3.5" />
      {status.expired ? t("personal.expired") : t("personal.expiresIn", { days: status.days })}
    </p>
  );
};
